import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, ValidationErrors, Validators} from "@angular/forms";
import { DomSanitizer } from '@angular/platform-browser';
import {HttpService} from "../../service/http.service";
declare var $: any

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.css']
})
export class AboutUsComponent implements OnInit {

  contact: FormGroup;
  disabled = true;
  message = '';
  aboutUsVideo = this.domSanitizer.bypassSecurityTrustResourceUrl(`https://player.vimeo.com/video/51553892`);

  constructor(
    private fb: FormBuilder,
    private http: HttpService,
    private domSanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.contact = this.fb.group({
      name: ['', Validators.compose([Validators.required])],
      email: ['', Validators.compose([Validators.required, Validators.email])],
      description: ['', Validators.compose([Validators.required])],
    });
    this.contact.valueChanges.subscribe((x) => {
      this.disabled = this.getFormValidationErrors();
    });
  }

  get f() { return this.contact.controls; }

  getFormValidationErrors() {
    const errors = [];
    Object.keys(this.contact.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.contact.get(key).errors;
      if (controlErrors != null) {
        errors.push(controlErrors);
      }
    });
    return errors.length > 0;
  }

  submitRequest($event) {

    this.http.submitContact(this.contact.value).subscribe((x) => {
      if (x.status) {
        this.message = 'Thank you for contacting us, we\'ll get back to you shortly.';
        this.contact.reset({});
      } else {
        this.message = x.message;
      }
    });
  }

  modalTriggerMethod(){
    $('#loginForm').modal('show');
  }
}
